import api from "@/lib/api";

export const trashAction = (entity, ids, action) =>
  api.post("/admin/trash/action", { entity, ids, action });

export const getTrash = () => api.get("/admin/trash").then(({ data }) => data);

export const emptyTrash = (entity) =>
  api.post("/admin/trash/empty", entity ? { entity } : {});
